export const SET_WELCOME_TOAST = 'SET_WELCOME_TOAST';

export const setWelcomeToast = (value) => ({
  type: SET_WELCOME_TOAST,
  payload: value,
});